/**
 * EnhancedGamePage - Route wrapper for the Enhanced 3D game
 */

import EnhancedGameWorld from '../components/game/EnhancedGameWorld';

export default function EnhancedGamePage() {
  return <EnhancedGameWorld />;
}
